import React, { useState, useMemo } from "react";
import { Box, Grid, Paper, Typography, Button, IconButton } from "@mui/material";
import { BarChart, TrendingUp, AttachMoney, People, Download, PieChart, Timeline } from '@mui/icons-material';
import DataGridTemplate from "../../layout/datagridtable";

const reportData = [
  { id: 1, metric: "Total Revenue", value: "$2.5M", change: "+15%", period: "This Month", color: "#2196f3" },
  { id: 2, metric: "Occupancy Rate", value: "78%", change: "+5%", period: "This Month", color: "#4caf50" },
  { id: 3, metric: "Average Daily Rate", value: "$245", change: "+8%", period: "This Month", color: "#ff9800" },
  { id: 4, metric: "Total Bookings", value: "1,234", change: "+12%", period: "This Month", color: "#e91e63" },
];

const propertyPerformance = [
  { id: 1, property: "Ocean View Villa", revenue: "$120,000", occupancy: "85%", rating: "4.8" },
  { id: 2, property: "Mountain Retreat", revenue: "$95,000", occupancy: "72%", rating: "4.6" },
  { id: 3, property: "City Apartment", revenue: "$85,000", occupancy: "68%", rating: "4.7" },
];

const Reports = () => {
  const columns = useMemo(
    () => [
      { field: "property", title: "Property Name" },
      { field: "revenue", title: "Monthly Revenue" },
      { field: "occupancy", title: "Occupancy Rate" },
      { field: "rating", title: "Guest Rating" },
    ],
    []
  );

  return (
    <Box sx={{ flexGrow: 1, p: 4, backgroundColor: '#f5f7fa' }}>
      <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 4 }}>
        <Typography variant="h4" sx={{ color: '#1a237e', fontWeight: 'bold' }}>
          Performance Reports
        </Typography>
        <Button 
          variant="contained" 
          startIcon={<Download />}
          sx={{
            background: 'linear-gradient(45deg, #1976d2 30%, #2196f3 90%)',
            boxShadow: '0 3px 5px 2px rgba(33, 150, 243, .3)',
          }}
        >
          Export Report
        </Button>
      </Box>

      <Grid container spacing={3}>
        {reportData.map((item) => (
          <Grid item xs={12} sm={6} md={3} key={item.id}>
            <Paper sx={{ 
              p: 3,
              borderRadius: 2,
              background: `linear-gradient(145deg, #ffffff, ${item.color}08)`,
              transition: 'transform 0.2s ease-in-out',
              '&:hover': {
                transform: 'translateY(-4px)',
                boxShadow: `0 8px 24px ${item.color}20`
              }
            }}>
              <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 2 }}>
                <Typography sx={{ color: '#666' }}>{item.metric}</Typography>
                <IconButton sx={{ backgroundColor: `${item.color}15`, color: item.color }}>
                  {item.metric.includes('Revenue') ? <AttachMoney /> : 
                   item.metric.includes('Occupancy') ? <People /> : 
                   item.metric.includes('Rate') ? <TrendingUp /> : <BarChart />}
                </IconButton>
              </Box>
              <Typography variant="h4" sx={{ color: item.color, fontWeight: 'bold', mb: 1 }}>
                {item.value}
              </Typography>
              <Typography sx={{ 
                color: item.change.includes('+') ? '#4caf50' : '#f44336',
                fontWeight: 'bold'
              }}>
                {item.change} vs Last Month
              </Typography>
            </Paper>
          </Grid>
        ))}
      </Grid>

      <Grid container spacing={3} sx={{ mt: 2 }}>
        <Grid item xs={12} md={6}>
          <Paper sx={{ 
            p: 3,
            borderRadius: 2,
            height: '300px',
            background: 'linear-gradient(145deg, #ffffff, #f8f9fa)'
          }}>
            <Box sx={{ display: 'flex', alignItems: 'center', mb: 2 }}>
              <Timeline sx={{ color: '#1976d2', mr: 1 }} />
              <Typography variant="h6">Revenue Trend</Typography>
            </Box>
            {/* Chart component would go here */}
          </Paper>
        </Grid>
        <Grid item xs={12} md={6}>
          <Paper sx={{ 
            p: 3,
            borderRadius: 2,
            height: '300px',
            background: 'linear-gradient(145deg, #ffffff, #f8f9fa)'
          }}>
            <Box sx={{ display: 'flex', alignItems: 'center', mb: 2 }}>
              <PieChart sx={{ color: '#4caf50', mr: 1 }} />
              <Typography variant="h6">Occupancy Distribution</Typography>
            </Box>
            {/* Chart component would go here */}
          </Paper>
        </Grid>
      </Grid>

      <Box sx={{ 
        mt: 4,
        p: 3,
        backgroundColor: '#ffffff',
        borderRadius: 2,
        boxShadow: '0 2px 10px rgba(0,0,0,0.08)'
      }}>
        <Typography variant="h5" sx={{ mb: 3, color: '#1a237e', fontWeight: 'bold' }}>
          Property Performance
        </Typography>
        <DataGridTemplate
          columns={columns}
          data={propertyPerformance}
          enableRowActions={false}
        />
      </Box>
    </Box>
  );
};

export default Reports;